import { render, staticRenderFns } from "./ThgCheckoutCard.vue?vue&type=template&id=5ecc8aa3&scoped=true"
import script from "./ThgCheckoutCard.vue?vue&type=script&lang=ts"
export * from "./ThgCheckoutCard.vue?vue&type=script&lang=ts"
import style0 from "./ThgCheckoutCard.vue?vue&type=style&index=0&id=5ecc8aa3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ecc8aa3",
  null
  
)

export default component.exports